module.exports = __webpack_public_path__ + "static/media/Celebrate.96862ac0.jpg";